module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"tx","link":"https://ripple.com/build/transactions/","description":"An object in rippled txJSON format","type":"object","properties":{"Account":{"$ref":"address"}},"required":["Account"]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/tx-json.json
// module id = X6uC
// module chunks = 1